import React, { useState, useEffect, useMemo } from "react";
import { Row, Table, Form, Button } from "react-bootstrap";
import { colors, initialCheckOut, paymentNameMaps } from "../configs";
import { useSelector } from "react-redux";
import { goToTop, handleDigit2, searchMultiFunction } from "../Utility/function";
import { stringDateTimeReceipt, stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
import { reverseSort } from "../Utility/sort";
import * as XLSX from 'xlsx';
import { Modal_Receipt } from "../modal";
import { Download, SearchControl, TimeControl } from "../components";

const { backgroundColor, dark, white } = colors;

function ReportBillScreen() {
  const { t } = useTranslation();
  const { selectedBill, selectedVoidedBill, startDate, endDate } = useSelector((state)=> state.bill);
  const { shop:{ POSs } } = useSelector(state=>state.shop); 
  const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [option, setOption] = useState('1');
  const [search, setSearch] = useState('');
  const [length, setLength] = useState(0);
  const [receipt_Modal, setReceipt_Modal] = useState(false);
  const [receipt, setReceipt] = useState(initialCheckOut);
  const [masterData, setMasterData] = useState([]);
  const [selectedPos, setSelecetdPos] = useState('')

  console.log(POSs)

  useEffect(()=>{
    let arr = []
    const cashiers = new Map(POSs.map(a=>[a.shiftId,a.name]))
    switch (option) {
        case '1':
            arr = reverseSort('dateTime',[...selectedBill,...selectedVoidedBill])
            break;
        case '2':
            arr = reverseSort('dateTime',[...selectedBill])
            break;
        case '3':
            arr = reverseSort('dateTime',[...selectedVoidedBill])
            break;
    
        default:
            break;
    };

    arr = arr.map(a=>({...a, counterName:cashiers.get(a.shiftId)||'ไม่พบ', net:a.net.toFixed(2)}))
    setMasterData(arr)
  },[selectedBill,selectedVoidedBill,option])


  const handleChangePage = (event, newPage) => {
      setPage(newPage); // start form 0
      goToTop()
  };

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      goToTop()
  };


  // ชุดหลังกรอง (ก่อนสไลซ์หน้า) — ตัวเดียวที่ตาราง · ป้ายจำนวน · ไฟล์ดาวน์โหลด อ้างร่วมกัน
  //   เดิม export อ่าน currentDisplay (สไลซ์แล้ว) ⇒ ไฟล์ได้แค่หน้าที่เปิดอยู่ 100 แถว
  //   (ลูกค้าแจ้ง 2026-09-10 "ขึ้นหน้าเดียวครับ" · คลาสเดียวกับ DEV-0975 ของ scanFood_Owner)
  const filteredRows = useMemo(()=>{
    let arr = masterData

    if(search){
        arr = searchMultiFunction(arr,search,['receiptNumber','profileName','tableName'])
    }

    if(selectedPos){
        arr = arr.filter(a=>a.posId === selectedPos)
    }
    return arr
  },[masterData,search,selectedPos])

  // เงื่อนไขกรองเปลี่ยน = ชุดผลลัพธ์คนละความยาว → กลับหน้า 1 เสมอ (กันตารางว่างทั้งที่ป้ายบอกว่าเจอ)
  useEffect(()=>{ setPage(0) },[search,option,selectedPos])

  useEffect(()=>{
    let fData = filteredRows.map((item,index)=>{return({...item,no:index+1})})
        .filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
    
    
      setCurrentDisplay(fData)
      setLength(filteredRows.length)
  },[page,rowsPerPage,filteredRows])

  const exportToXlsx = () => {
    // ทั้งชุดที่กรองแล้ว (ทุกหน้า) ไม่ใช่แค่หน้าที่เปิดอยู่
    const data = filteredRows.map((a) => {
      const { 
        receiptNumber, 
        counterName, 
        dateTime, 
        cashierName, 
        payment, 
        reason, 
        moneyMustPaid, 
        void: voidStatus 
      } = a;
  
      
      return {
        ใบเสร็จ: receiptNumber,
        เวลา: stringDateTimeReceipt(dateTime),
        เครื่องแคชเชียร์: counterName,
        พนักงานขาย: cashierName,
        ชำระเงิน: payment.map(a=>a.name).join('/'),
        ยอดสุทธิ: moneyMustPaid,
        สถานะ: voidStatus?'ใบเสร็จที่ยกเลิก':'ใบเสร็จปกติ',
        เหตุผล: reason,
      }
    });
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ประวัติใบเสร็จ');
  
    const fileName = `ประวัติใบเสร็จ(${selectedPos?POSs.find(a=>a.id===selectedPos)?.name:'ทั้งหมด'}) ${stringYMDHMS3(startDate)}-${stringYMDHMS3(endDate)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };


  return (
    <div style={{ minHeight:'100vh' }} >
        <Modal_Receipt
            show={receipt_Modal}
            onHide={()=>{setReceipt_Modal(false)}}
            data={receipt}
        />
        <div style={{ position:"sticky", top:0, zIndex:9, backgroundColor }} >
            <h1>ข้อมูลใบเสร็จ</h1>
            <TimeControl/>
            <div style={{  display:'flex',alignItems:'center' }} >
            &emsp;
                <SearchControl {...{ placeholder:t('bill.search'), search, setSearch }} />&emsp;
                <Form.Select 
                        aria-label="Default select example" 
                        value={option} 
                        onChange={(event)=>{
                        event.preventDefault()
                            setOption(event.target.value)
                        }}
                        style={{width:'180px'}}
                    >
                        <option value="1" >ใบเสร็จทั้งหมด</option>
                        <option value="2" >ใบเสร็จปกติ</option>
                        <option value="3" >ใบเสร็จที่ยกเลิก</option>
                </Form.Select>
                <Download exportToXlsx={exportToXlsx} />
            </div>
        </div>
        <br/>
        <h4>&emsp;{t('bill.result',{ length:handleDigit2(length) })}</h4>
        <div style={{ width: '100%', overflowX: 'auto'}} >
            <div style={{ display: 'flex' }}>
                <div onClick={()=>{setSelecetdPos('')}} style={{ padding:10, margin:10, minWidth:'150px', backgroundColor:!selectedPos?dark:white, color:selectedPos?dark:white, borderRadius:20, cursor:'pointer', display:'flex', justifyContent:'center', alignItems:'center' }} >ทั้งหมด</div>
                {POSs.map((item,index)=>{
                    const status = selectedPos === item.id;
                    const backgroundColor = status?dark:white;
                    const color = !status?dark:white;
                    return <div onClick={()=>{setSelecetdPos(item.id)}} style={{ padding:10, margin:10, minWidth:'150px', backgroundColor, color, borderRadius:20, cursor:'pointer', display:'flex', justifyContent:'center', alignItems:'center' }} key={index} >{item.name}</div>
                })}
            </div>
            
        </div>
        <Row>
                <Table striped bordered hover responsive  variant="light" style={styles.container2}   >
                    <thead  >
                    <tr>
                        <th style={styles.container3}>No.</th>
                        <th style={styles.container4}>ใบเสร็จ</th>
                        <th style={styles.container4}>เวลา</th>
                        <th style={styles.container4}>เครื่องแคชเชียร์</th>
                        <th style={styles.container4}>พนักงานขาย</th>
                        <th style={styles.container4}>ชำระเงิน</th>
                        <th style={styles.container4}>ยอดสุทธิ</th>
                        <th style={styles.container4}>สถานะ</th>
                        {option==='3'
                            ?<React.Fragment>
                                <th style={styles.container4}>เหตุผล</th>
                                <th style={styles.container4}>ยกเลิกโดย</th>
                            </React.Fragment>
                            :null
                        }
                        <th style={styles.container4}>รายละเอียด</th>
                    </tr>
                  </thead>
                  <tbody  >
                    {currentDisplay.map((item, index) => {
                        const { receiptNumber, dateTime, counterName, cashierName, moneyMustPaid, reason, voidStaff, no, void:voidStatus, payment } = item;
                        return <tr  style={{cursor: 'pointer'}} key={index} >
                                    <td style={styles.container3} >{no}.</td>
                                    {/* <td style={styles.container4}>{productDiscount}</td> */}
                                    <td style={styles.container4}>{receiptNumber}</td>
                                    <td style={styles.container4} >{stringDateTimeReceipt(dateTime)}</td>
                                    <td style={styles.container4} >{counterName}</td>
                                    <td style={styles.container4} >{cashierName}</td>
                                    <td style={styles.container4} >{payment.map(a=>a.name || paymentNameMaps[a.id]).join('/')}</td>
                                    <td style={styles.container4} >{moneyMustPaid}</td>
                                    <td style={styles.container4}>{voidStatus?'ใบเสร็จที่ยกเลิก':'ใบเสร็จปกติ'}</td>
                                    {option==='3'
                                        ?<React.Fragment>
                                            <td style={styles.container4}>{reason}</td>
                                            <td style={styles.container4}>{voidStaff}</td>
                                        </React.Fragment>
                                        :null
                                    }
                                    <td style={styles.container4} >
                                        <Button onClick={()=>{setReceipt(item);setReceipt_Modal(true)}} variant="warning" style={{width:'100px'}} >{t('bill.watch')}</Button>
                                    </td>
                                </tr>
                    })}
                  </tbody>
                </Table>
                <TablePagination
                    component="div"
                    count={length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Row>
    </div>
  );
};

const styles = {
    container : {
        display:'flex',alignItems:'center'
    },
    container2 : {
        marginLeft:'1rem'
    },
    container3 : {
        width: '5%', minWidth:'150px', textAlign:'center' 
    },
    container4 : {
        width: '9%', minWidth:'150px', textAlign:'center' 
    }
}

export default ReportBillScreen;
